import type { NavLinkProps } from '@/types';

export const checkHasSubmenu = (
  link: NavLinkProps,
): link is Required<NavLinkProps> => Array.isArray(link.submenu);
